export enum OrderType {
  INDIVIDUAL = 'individual_order',
  COMBINED = 'combined_order',
  GIFT_CARD = 'gift_card_order',
}
